const normalizeId = value => {
  if (value && typeof value === 'object') return value.id || Reflect.get(value, '_id') || null

  return value || null
}

const isContentPackId = value => String(value || '').trim().toUpperCase() === 'CONTENTPACK'

export const getContentPackItemIds = (contentPacks, sectionKey, subsectionKey) => {
  const itemIds = new Set()
  const items = Array.isArray(contentPacks)
    ? contentPacks
    : contentPacks?.contentPacks || contentPacks?.items || contentPacks?.data || []
  const activeContentPacks = items.filter(contentPack => !contentPack.deleted)

  activeContentPacks.forEach(contentPack => {
    const references = contentPack?.[sectionKey]?.[subsectionKey] || []
    references.forEach(reference => {
      const id = normalizeId(reference)
      if (id) itemIds.add(id)
    })
  })

  return itemIds
}

export const getAcademyDisplay = (item, contentPackItemIds) => {
  const itemId = normalizeId(item?.id || Reflect.get(item || {}, '_id'))
  const academyId = item?.academyId ?? item?.companyId ?? null
  const isInContentPack = contentPackItemIds.has(itemId)

  if (isContentPackId(academyId)) return 'Contentpack'
  if (isInContentPack && !academyId) return 'Global &<br>Contentpack'
  if (!academyId) return 'Global'

  return item?.academy || item?.academyName || academyId
}
